import { useCallback, useRef } from 'react'
import { GripVertical } from 'lucide-react'

type Props = {
  onResize: (deltaX: number) => void
}

export function ResizableDivider({ onResize }: Props) {
  const startX = useRef(0)

  const handleMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault()
      startX.current = e.clientX
      let lastX = e.clientX

      const handleMouseMove = (me: MouseEvent) => {
        const delta = me.clientX - lastX
        lastX = me.clientX
        onResize(delta)
      }
      const handleMouseUp = () => {
        document.removeEventListener('mousemove', handleMouseMove)
        document.removeEventListener('mouseup', handleMouseUp)
        document.body.style.cursor = ''
      }

      document.body.style.cursor = 'col-resize'
      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', handleMouseUp)
    },
    [onResize],
  )

  return (
    <div
      className="relative flex-shrink-0 w-px bg-border cursor-col-resize group"
      onMouseDown={handleMouseDown}
    >
      <div className="absolute inset-y-0 -left-2 -right-2" />
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"
      >
        <GripVertical className="w-3 h-3 text-muted-foreground" strokeWidth={1.5} />
      </div>
    </div>
  )
}
